module.exports = __webpack_public_path__ + "media/images/avatar-3f28b642.png";